import { ConnectComponent } from "util";
import View from "./view";
import Presenter from "./presenter";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/management/payments-report/report-email/index.js